import request from '@/router/axios'

export function getGameType () {
  return request({
    url: '/api.php/Ajax/getCateData',
    method: 'get'
  })
}
